import React, {useContext, useEffect, useMemo, useState} from "react"
import {Box, IconButton, Typography} from "@mui/material";
import {MapDataContext} from "../map";
import {AppDataContext} from "../../../../App";
import {Close as CloseIcon} from "@mui/icons-material";
import UseMainListColumnDefs from "../list/columnDefs";
import _ from "lodash";
import useAgGridManager from "../../../manager/agGrid";
import PropTypes from "prop-types";

const styles = {
    root: {
        display: 'flex',
        flexDirection: 'row',
        margin: '8px',
        gap: '8px',
        alignItems: "center",
        height: "40px",
    },
    label: {
        fontSize: '13px',
        color: '#333',
    },
    selectedBox: {
        fontSize: '12px',
        background: 'rgb(255 230 57)',
        padding: '7px 8px',
        borderRadius: '8px',
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        gap: '8px',
    },
    selectedDeleteButtonIcon: {
        fontSize: '14px',
    },
    selectedLabel: {

    },
    conditionBox: {

    },
    conditionLabel: {

    },
    clearButton: {

    },
}

const MainFilterView = ({onRemoveFilter}) => {

    const { state, setSelectedTreeModel, } = useContext(AppDataContext)
    const [conditions, setConditions] = useState([])
    const { getFilterComponent } = useAgGridManager()

    return (
        <Box style={styles.root}>
            <Typography style={styles.label}>選択中:</Typography>
            {state.selectedTreeModel && (
                <Box style={styles.selectedBox}>
                    {state.selectedTreeModel?.tree_id && (<Typography>{state.selectedTreeModel.tree_id}</Typography>)}
                    {!state.selectedTreeModel?.tree_id && (<Typography>{state.selectedTreeModel.type}({state.selectedTreeModel.name ?? "種名不明"})</Typography>)}
                    <IconButton size="small" onClick={() => setSelectedTreeModel(null)}>
                        <CloseIcon style={styles.selectedDeleteButtonIcon} />
                    </IconButton>
                </Box>
            )}
            <Typography style={styles.label}>フィルタ:</Typography>
            {state.filterModel && Object.entries(state.filterModel).map(([key, filter]) => {
                const colDef = state.columnDefs.find(v => v.field === key)
                return (
                    <Box>
                        {getFilterComponent({filter, colDef, onRemove: () => onRemoveFilter(filter, colDef)})}
                    </Box>
                )
            })}
        </Box>
    )
}

MainFilterView.propTypes = {
    onRemoveFilter: PropTypes.func.isRequired,
}

export default MainFilterView
